import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
import { BusinessModifierGroupManagerHandler } from '../../providers/business-modifier-group-handler';
import { BusinessProductSubcategoryModifierManagerPage } from '../business-product-subcategory-modifier-manager/business-product-subcategory-modifier-manager';
import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-modifier-group-manager',
  templateUrl: 'business-modifier-group-manager.html',
})
export class BusinessModifierGroupManagerPage {
	group: any;
	modifiers: any = [];
	private form : FormGroup;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	isRefreshing: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;

  	constructor(  		
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public managerHandler: BusinessModifierGroupManagerHandler,
		public storage: Storage,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		public _DomSanitizer: DomSanitizer
		) {

  		this.group = navParams.get('group');
		
	    this.form = this.formBuilder.group({
	    	"Id": [''],
		  	"ModifierGroupName":  ['', Validators.required],
		    "IsActive": [true],
	   	});   
  	}

  	ionViewWillEnter() {
		if(this.group.Id){
	   		this.load(this.group.Id);
	    } 
	}

	load(id){
		this.isLoading = true;

		this.managerHandler.getModifierGroup(id, (result)=>{
		  	
		  	if(result.group.Id != ''){
		  		this.group = result.group;

		  		this.form.patchValue(
					this.group
		    	)

		    	this.modifiers = result.modifiers;
		  	}

		  	this.isLoading = false;
		})
	}

	delete(){
		this.deleteIsLoading = true;
		
		this.managerHandler.delete(this.group.Id, (result)=>{
			this.deleteIsLoading = true;

			if(result.Success)
				this.navCtrl.pop();
			else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});			
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this group?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.delete()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	onSubmit(){
		if(this.saveIsLoading)
			return

		this.saveIsLoading = true;

		if(this.form.value.Id != ''){

			console.log("entered update");

			this.managerHandler.update(this.form.value.Id, this.form.value, (result)=>{
				if(result.Success){
					let toast = this.toastCtrl.create({
						message: 'Group has been updated',
						duration: 3000,
						position: 'bottom'
					});

					this.group.ModifierGroupName = this.form.value.ModifierGroupName;

					toast.present();						
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}

				this.saveIsLoading = false;
			})

		} else {
			console.log("entered create");

			this.managerHandler.create(this.form.value, (result)=>{
				if(result.Success){
					this.load(result.Data.Id);
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			  				  	
				this.saveIsLoading = false;
			})
		}		  	
	}

	create(){
	    this.navCtrl.push(BusinessProductSubcategoryModifierManagerPage, {
	      modifier: {},
	      group: this.group
	    });		
	}

	manage($e, modifier){
	    this.navCtrl.push(BusinessProductSubcategoryModifierManagerPage, {
	      modifier: modifier,
	      group: this.group
	    });				
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-modifier-group-manager/business-modifier-group-manager.ts